import toast from "react-hot-toast";
import { CallingApp, CaseType, CaseTypeList, Data, StateList } from "../Constant";

export const CustomLabelRequired = ({ text }) => {
  return (
    <label
      className="form-control-label mb-0"
      style={{ fontSize: 10, fontWeight: "bold" }}
    >
      {" "}
      {text}
      <span style={{ color: "red" }}>*</span>
    </label>
  );
};

export const CustomLabel = ({ text }) => {
  return (
    <label
      className="form-control-label mb-0"
      style={{ fontSize: 10, fontWeight: "bold" }}
    >
      {" "}
      {text}
    </label>
  );
};

export function GetAccessApiToken() {
  let Token = sessionStorage.getItem("accessApiToken");
  Token = JSON.parse(Token);
  return Token;
}

export function GetCommonServiceToken() {
  let Token = JSON.parse(sessionStorage.getItem("commonServiceToken"));
  return Token;
}

export const getSessionData = (key, defaultValue = null) => {
  try {
    const item = sessionStorage.getItem(key);
    return item ? JSON.parse(item) : defaultValue;
  } catch (error) {
    console.error(`Error parsing sessionStorage key: ${key}`, error);
    return defaultValue;
  }
};


export const setSessionItem = (key, value) => {
  try {
    sessionStorage.setItem(key, JSON.stringify(value));
  } catch (error) {
    console.error(`Error setting key: ${key} in sessionStorage:`, error);
  }
};


export const removeSessionItem = (key) => {
  try {
    sessionStorage.removeItem(key);
  } catch (error) {
    console.error(`Error removing key: ${key} from sessionStorage:`, error);
  }
};

export const getStateNameById = (stateId) => {
  const stateList = getSessionData(StateList, []);
  const state = stateList.find((state) => state.stateId === stateId);
  return state ? state.stateName : "Unknown State";
}

export const getCaseTypeNameById = (caseTypeId) => {
  const caseTypeList = getSessionData(CaseTypeList, []);
  const caseType = caseTypeList.find((caseType) => caseType.caseTypeId === caseTypeId);
  return caseType ? caseType.caseTypeName : "";
}

export const getPatientAge = (dateOfBirth) => {
  const dob = new Date(dateOfBirth);
  const today = new Date();

  let age = today.getFullYear() - dob.getFullYear();
  const monthDiff = today.getMonth() - dob.getMonth();

  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dob.getDate())) {
    age--;
  }

  return age;
}

export const getMaritalStatus = (key) => {
  const statusMap = {
    "1": "Single",
    "2": "Married",
    "3": "Other",
  };

  return statusMap[key] || "";
};

export const BuildInsuranceAddress = (patientDetails) => {
  const parts = [
    patientDetails?.insuranceAddress,
    patientDetails?.insuranceStreet,
    patientDetails?.insuranceCity,
    patientDetails?.insuranceState,
    patientDetails?.insuranceZip,
  ]
    .filter(Boolean)
    .join(" ");

  return parts;
};

var Current_Environement = {};
export const CURRENT_CONFIG = Current_Environement;